document.addEventListener("DOMContentLoaded", function () {

    const sliders = document.querySelectorAll("[data-slider]");

    sliders.forEach(function (slider) {

        const section = slider.closest(".fic-section");
        if (!section) return;

        const dotsWrap = section.querySelector("[data-dots]");
        const cards = Array.from(slider.children);

        if (cards.length === 0) return;

        let index = 0;
        let autoplayTimer = null;
        let isHovering = false;

        const speed = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;

        /*
        Visible cards per breakpoint:
        - Desktop / laptop (>1024px): 4
        - Tablet (768px - 1024px): 3
        - Mobile (<=767px): 2
        */
        function getVisibleItems() {

            const width = window.innerWidth;

            if (width <= 767) {
                return 2;
            }

            if (width <= 1024) {
                return 3;
            }

            return 4;
        }

        function getCardWidth() {

            const card = cards[0];
            const gap = parseInt(getComputedStyle(slider).gap) || 0;

            return card.getBoundingClientRect().width + gap;
        }

        function getMaxIndex() {

            return Math.max(0, cards.length - getVisibleItems());
        }

        function getTotalPages() {

            return Math.max(1, Math.ceil(cards.length / getVisibleItems()));
        }

        function getCurrentPage() {

            const visible = getVisibleItems();
            return Math.min(Math.round(index / visible), getTotalPages() - 1);
        }

        function buildDots() {

            if (!dotsWrap) return;

            dotsWrap.innerHTML = "";

            const totalPages = getTotalPages();

            // No dots needed if everything fits on one screen
            if (cards.length <= getVisibleItems()) {
                dotsWrap.style.display = "none";
                return;
            }

            dotsWrap.style.display = "flex";

            for (let i = 0; i < totalPages; i++) {

                const dot = document.createElement("button");
                dot.type = "button";
                dot.className = "fic-dot";
                dot.setAttribute("aria-label", "Go to slide " + (i + 1));

                dot.addEventListener("click", function () {

                    const visible = getVisibleItems();
                    index = Math.min(i * visible, getMaxIndex());
                    updateSlider();
                });

                dotsWrap.appendChild(dot);
            }
        }

        function updateDots() {

            if (!dotsWrap) return;

            const dots = dotsWrap.querySelectorAll(".fic-dot");
            const currentPage = getCurrentPage();

            dots.forEach(function (dot, i) {
                dot.classList.toggle("is-active", i === currentPage);
            });
        }

        function updateSlider() {

            const maxIndex = getMaxIndex();

            if (index > maxIndex) index = maxIndex;
            if (index < 0) index = 0;

            const move = index * getCardWidth();
            slider.style.transform = "translateX(-" + move + "px)";

            updateDots();
        }

        function goToNextPage() {

            const visible = getVisibleItems();
            const maxIndex = getMaxIndex();

            index += visible;

            if (index > maxIndex) {
                index = 0; // loop back to start — continuous auto scroll
            }

            updateSlider();
        }

        /*
        Touch swipe
        */
        let startX = 0;
        let endX = 0;

        slider.addEventListener("touchstart", function (e) {
            startX = e.touches[0].clientX;
        }, { passive: true });

        slider.addEventListener("touchend", function (e) {

            endX = e.changedTouches[0].clientX;
            const visible = getVisibleItems();

            if (startX - endX > 50) {
                index = Math.min(index + visible, getMaxIndex());
            }

            if (endX - startX > 50) {
                index = Math.max(index - visible, 0);
            }

            updateSlider();
        }, { passive: true });

        /*
        Mouse drag
        */
        let dragging = false;
        let dragStart = 0;

        slider.addEventListener("mousedown", function (e) {
            dragging = true;
            dragStart = e.clientX;
            slider.style.cursor = "grabbing";
        });

        slider.addEventListener("mouseup", function (e) {

            if (!dragging) return;

            const distance = dragStart - e.clientX;
            const visible = getVisibleItems();

            if (distance > 50) {
                index = Math.min(index + visible, getMaxIndex());
            }

            if (distance < -50) {
                index = Math.max(index - visible, 0);
            }

            updateSlider();
            dragging = false;
            slider.style.cursor = "";
        });

        slider.addEventListener("mouseleave", function () {
            dragging = false;
        });

        /*
        Autoplay — always on, loops continuously.
        Pauses on hover so users can browse.
        */
        function startAutoplay() {

            stopAutoplay();

            autoplayTimer = setInterval(function () {
                if (!isHovering) {
                    goToNextPage();
                }
            }, speed);
        }

        function stopAutoplay() {

            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        }

        section.addEventListener("mouseenter", function () {
            isHovering = true;
        });

        section.addEventListener("mouseleave", function () {
            isHovering = false;
        });

        let resizeTimer;
        window.addEventListener("resize", function () {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                index = 0;
                buildDots();
                updateSlider();
            }, 150);
        });

        buildDots();
        updateSlider();
        startAutoplay();
    });
});